var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name==='Home')?_c('div',{staticClass:"fixed-bottom"},[_c('p',[_vm._v(_vm._s(_vm.userEmail))]),_c('button',{staticClass:"btn text-link mx-auto",on:{"click":_vm.logout}},[_vm._v(" Logout ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }